import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplexityEstimationResult } from '../../shared/complexity-mgnt/complexity-estimation-result';
import { ComplexityMngtService } from '../../shared/complexity-mgnt/complexity-mngt.service';
import { PreaggregationSevice } from '../../shared/preaggregation/preaggregation-service';
import { ComplexityColumn } from '../../shared/complexity-mgnt/complexity-column';
import { ProjectService } from 'src/app/shared/project/project.service';

@Component({
  selector: 'app-complexity-mgnt',
  templateUrl: './complexity-mgnt.component.html',
  styleUrls: ['../general.scss', './complexity-mgnt.component.scss']
})
export class ComplexityMgntComponent implements OnInit {
    public loading: boolean = true;
    public projectId: string;

    public multiplier: number = 1;
    public greenPerc: number = 20;
    public yellowPerc: number = 10;
    public redPerc: number = 5;
    public roundedMultiplier: string;
    public roundedMultiplierDesc: string;
    public columns: ComplexityColumn[];
    public removeMinNRows: number = undefined;
    private wantBenchmarks = false;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, 
        private preaggregationSevice: PreaggregationSevice, private complexityMngtService: ComplexityMngtService,
        private projectService: ProjectService) { }

        ngOnInit(): void {
            this.loading = true;
            this.activatedRoute.queryParams.subscribe((queryParams: any) => {
                let projectId = queryParams.projectId;
                this.wantBenchmarks = queryParams.benchmarks === 'true';
                if (projectId) {
                    this.projectId = projectId;
                    this.projectService.setProjectId(projectId);
                    this.complexityMngtService.getComplexityEstimation(projectId)
                    .then(resp => {
                        if (!resp.showToUser) {
                            this.proceedToNextPage();
                        }
                        this.loadModel(resp);
                        this.loading = false;
                    });
                }
            });
        }

    public async removeColumn(i: number) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.complexityMngtService.removeColumn(this.projectId, i);
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    public async unremoveColumn(i: number) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.complexityMngtService.unremoveColumn(this.projectId, i);
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    async save() {
        if (this.loading) {
            return;
        }

        //save here

        try {
            this.loading = true;
            this.proceedToNextPage();
        } finally {
            this.loading = false;
        }
    }

    private loadModel(model: ComplexityEstimationResult) {
        this.loadColorBar(model.multiplier);
        this.roundedMultiplier = model.roundedMultiplier;
        this.roundedMultiplierDesc = model.roundedMultiplierDesc;
        this.columns = model.columns;
        this.removeMinNRows = model.removeMinNRows;
    }

    private loadColorBar(mult: number): void {
        this.multiplier = mult;
        console.log('mult = ' + mult);
        this.greenPerc = 100 / mult;
        if (this.greenPerc < 5) {
            this.greenPerc = 5;
        } else if (this.greenPerc > 100) {
            this.greenPerc = 100;
        }
        if (mult < 1 ) {
            this.yellowPerc = 0;
        } else if (mult > 2) {
            this.yellowPerc = this.greenPerc;
        } else {
            this.yellowPerc = (mult - 1) * (100 / mult);
        }
        if (this.yellowPerc > 0 && this.yellowPerc < 5) {
            this.yellowPerc = 5;
        }
        if (mult > 2) {
            this.redPerc = 100 - this.greenPerc - this.yellowPerc;
        } else {
            this.redPerc = 0;
        }
    }

    public goBackReselectDimensions() {
        this.router.navigateByUrl('/select-columns-dimensions?projectId=' + this.projectId);
    }

    public proceedToNextPage() {
        this.preaggregationSevice.requiresPreaggregation(this.projectId).then(requires => {
            if (requires) {
                this.router.navigateByUrl(`/preaggregation?projectId=${this.projectId}&benchmarks=${this.wantBenchmarks}`);
            } else if (this.wantBenchmarks) {
                this.router.navigateByUrl('/series?projectId=' + this.projectId);
            } else {
                this.router.navigateByUrl('/cards?projectId=' + this.projectId);
            }
        });
    }

    public async removeColumnCompression(dimIndex) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.complexityMngtService.removeColumnCompression(this.projectId, dimIndex);
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }
}
